import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Joi from "joi-browser";
import Form from "../components/Form";
import auth from "../services/portalAuthService";
import { Link, Navigate } from "react-router-dom";
import { showErrorToast } from "V2.0/utils";
import Logo from "./common/Logo";
import { message } from "antd";

function Login(props) {
  const [inputField] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [errorMessage] = useState({});
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const reason = searchParams.get("reason");

    if (reason) {
      message.error(reason);
    }
  }, [searchParams]);

  const template = [
    {
      name: "email",
      label: "Email *",
      type: "email",
      placeholder: "youremail@example.com",
    },
    {
      name: "password",
      label: "Password *",
      type: "password",
      placeholder: "Minimum 8 characters",
      info: (
        <Link
          to="/forgot-password"
          className="text-xs text-zinc-950 hover:text-zinc-700 dark:text-white dark:hover:text-zinc-300"
        >
          Forgot password?
        </Link>
      ),
    },
  ];

  const buttonInfo = {
    label: "Log In",
    style: "entire-width",
  };

  const schema = {
    email: Joi.string().email().required().label("Email"),
    password: Joi.string().min(8).required().label("Password"),
  };

  const handleSubmit = async ({ email, password }) => {
    try {
      await auth.login(email, password);
      window.location.href = window.location.origin;
    } catch (e) {
      setLoading(false);
      showErrorToast(e, "Login failed");
    }
  };

  return auth.getCurrentUser() ? (
    <Navigate to="/" />
  ) : (
    <div className="bg-slate-50 flex items-center justify-center h-screen w-screen">
      <div className="relative w-[500px] rounded-xl bg-white shadow-[0px_0px_0px_1px_rgba(9,9,11,0.07),0px_2px_2px_0px_rgba(9,9,11,0.05)] dark:bg-zinc-900 dark:shadow-[0px_0px_0px_1px_rgba(255,255,255,0.1)] p-20">
        <div className="space-y-8">
          <Logo />
          <Form
            formTitle={"Log In to your Account"}
            errorMessage={errorMessage}
            inputField={inputField}
            template={template}
            schema={schema}
            buttonInfo={buttonInfo}
            onSubmit={handleSubmit}
            loading={loading}
            setLoading={setLoading}
          />
          {/* <div className="flex flex-col space-y-4">
            <p className="text-base text-zinc-500 sm:text-sm dark:text-zinc-400">
              Don’t have an account?{" "}
              <Link
                to="/signup"
                className="font-semibold text-zinc-950 hover:text-zinc-700 dark:text-white dark:hover:text-zinc-300"
              >
                Create one
              </Link>
            </p>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default Login;
